window.NVC_Opt = {
  //无痕配置 && 滑动验证、刮刮卡通用配置
  appkey: 'FFFF0N00000000008DB7',
  // appkey:'CF_APP_1',
  scene: 'nvc_login',
  // scene: "nvc_register",
  isH5: false,
  popUp: false,
  renderTo: '#captcha',
  trans: {
    key1: 'code0',
    nvcCode: 400
  },
  language: 'cn',
  //滑动验证长度配置
  customWidth: 300,
  //刮刮卡配置项
  width: 300,
  height: 125,
  elements: [
    'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/20200320170711.png',
    'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/20200320170711.png'
  ],
  bg_back_prepared:
    '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
  bg_front:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
  obj_ok:
    'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/20200320170726.png',
  bg_back_pass:
    '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
  obj_error:
    'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/20200320170723.png',
  bg_back_fail:
    'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/20200320170723.png',
  upLang: {
    cn: {
      _ggk_guide: '请摁住鼠标左键，刮出两面盾牌',
      _ggk_success: '恭喜您成功刮出盾牌<br/>继续下一步操作吧',
      _ggk_loading: '加载中',
      _ggk_fail: [
        '呀，盾牌不见了<br/>请',
        'javascript:noCaptcha.reset()',
        '再来一次'
      ],
      _ggk_action_timeout: [
        '我等得太久啦<br/>请',
        'javascript:noCaptcha.reset()',
        '再来一次'
      ],
      _ggk_net_err: [
        '网络实在不给力<br/>请',
        'javascript:noCaptcha.reset()',
        '再来一次'
      ],
      _ggk_too_fast: [
        '您刮得太快啦<br/>请',
        'javascript:noCaptcha.reset()',
        '再来一次'
      ]
    }
  }
}